import { HttpTransportType } from '@aspnet/signalr'

export default {
  name: 'ClientMixin',
  data () {
    return {
      // audio: {
      //   alarm: null,
      //   isLoad: false,
      //   message: null,
      // },
    }
  },
  computed: {
    clients () {
      return this.$store.getters.appClients
    },
  },
  methods: {
    onPageDestroy () {
      this.closeSignalRConnection()
    },
    closeSignalRConnection () {
      if (typeof this.$socket.stop !== 'function') {
        return
      }
      this.$socket.stop()
    },
    makeSignalRConnection () {
      const groupName = 'dashboard-' + this.$store.getters.authenticationData.namespace + '-' + 0 + '-' +
        this.$store.getters.localUser.companyId + '-' +
        this.$store.getters.localUser.userId
      if (this.$store.getters.token && this.$store.getters.localUser.isConfirm) {
        if (this.$socket._isMounted) {
          return
        }
        this.closeSignalRConnection()
        const socketUrl = process.env.VUE_APP_SOCKET_URL + '/progressHub'
        if (this.$socket.connection !== socketUrl) {
          this.$socket.connection = socketUrl
        }
        this.$socket.authenticate(this.$store.getters.token + '&groupName=' + groupName, {
          log: false,
          skipNegotiation: false,
          keepAlive: 240,
          transport: HttpTransportType.WebSockets,
        })
      }
    },
    // playAlarmSound (message = null) {
    //   this.audio.alarm = new Audio('@/src/assets/sound/alarm.mp3')
    //   this.audio.alarm.onerror = (error) => {
    //     console.error('Error loading audio:', error)
    //   }
    //   this.audio.alarm.play()
    //   this.audio.message = message
    //   this.audio.isLoad = true
    //
    //   const that = this
    //   // replay sound infinite until close
    //   this.audio.alarm.addEventListener('ended', () => {
    //     that.audio.alarm.currentTime = 3
    //     that.audio.alarm.play()
    //   }, false)
    // },
    // async closeAudioAlarm () {
    //   if (!this.audio.isLoad) {
    //     return
    //   }
    //   this.audio.alarm.pause()
    //   this.audio.alarm.currentTime = 0
    //   this.audio.isLoad = false
    //   this.audio.message = null
    // },
  },
  watch: {
  },
  sockets: {
    dashboardSocketListener (data) {
      if (data.type === 'new') {
        // it's not new if already a client. Skip here!
        if (this.$store.getters.appClients.some(c => c.clientId === data.client.clientId)) {
          return
        }
        data.client.images = []
        this.$store.commit('new_client', data.client)
        return
      }
      if (data.type === 'remove') {
        this.$store.commit('remove_client', data.clientId)
        return
      }
      this.$store.getters.appClients.map((item) => {
        if (item.clientId === data.clientId) {
          const updatedItem = { ...item }
          if (data.type === 'change') {
            if (data.message === 'request') {
              // this.closeAudioAlarm()
              // this.playAlarmSound(data.client.plate)
            }
            if (data.message === 'update') {
              updatedItem.images = data.client.images
              updatedItem.plate = data.client.plate
              if (data.client.status === 'update') {
                updatedItem.status = 'taken'
              }
            } else {
              updatedItem.status = data.message
            }
          }
          if (data.type === 'location') {
            updatedItem.spotLatitude = data.client.spotLatitude
            updatedItem.spotLongitude = data.client.spotLongitude
          }
          if (data.type === 'info_change') {
            updatedItem.cardNo = data.client.cardNo
            updatedItem.mobile = data.client.mobile
            updatedItem.plate = data.client.plate
          }
          if (data.type === 'payment') {
            updatedItem.isPaymentCompleted = data.isPaymentCompleted
          }
          updatedItem.isActionPending = false
          if (data.paymentMethod !== null) {
            updatedItem.paymentMethod = data.paymentMethod
            updatedItem.status = data.message
          }
          this.$store.commit('remove_client', data.clientId)
          this.$store.commit('new_client', updatedItem)
          return updatedItem
        }
        return item
      })
    },
  },
  created () {
    if (this.$store.getters.isLoggedIn) {
      this.makeSignalRConnection()
    }
  },
  beforeMount () {
    window.addEventListener('beforeunload', () => {
      this.onPageDestroy()
    })
  },
  mounted: function () {
  },
}
